
const packageJson = require('../package.json');

export function getVersionString() {
    return packageJson.version;
}

export function getAppName() {
    return `MezCalc`;
}

export function getAppNameWithVersion() {
    return `${getAppName()} v${getVersionString()}`;
}

export function clearPageBackground() {
    document.getElementsByTagName('html')[0].style.background = '';
    document.getElementsByTagName('html')[0].style.backgroundSize = '';
    document.body.style.background = '';
}

export function setPageBackground(url) {
    document.getElementsByTagName('html')[0].style.background = `url(${url}) no-repeat center center fixed`;
    document.getElementsByTagName('html')[0].style.backgroundSize = 'cover';
    document.body.style.background = 'transparent';
}

export function setPageOverflow(overflow) {
    document.body.style.overflow = overflow;
}
